import { provider } from "../../providers";

export interface MakePlayerAdminPayload {
  groupId: number;
  playerId: number;
}

export const MakePlayerAdmin = async (params: MakePlayerAdminPayload): Promise<boolean> =>
  provider.Request("/make-player-admin", params);
